/* src/app/private/components/department/create-department/create-department.component.scss */
/*# sourceMappingURL=create-department.component.css.map */
